import { render } from "./ModelingJobContainerTags.vue?vue&type=template&id=a94bf5e0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__